const initialState = {
  isFetching: false,
  conditionStatistics: {},
  stateStatistics: {},
  connectionStatistics: {},
  faultsStatistics: {},
  aggregatedStatistics: {},
  totalEnergyStatistics: {},
  selectedCustomerId: null,
};

const statistics = (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initialState;

    case 'STATISTICS_REQUEST':
      return { ...state, isFetching: true };

    case 'CLEAR_STATISTICS':
      return initialState;

    case 'SET_CONDITION_STATISTICS_DATA':
      return { ...state, conditionStatistics: action.data, isFetching: false };

    case 'SET_SELECTED_CUSTOMER_ID':
      return { ...state, selectedCustomerId: action.data };

    case 'SET_STATE_STATISTICS_DATA':
      return { ...state, stateStatistics: action.data, isFetching: false };

    case 'SET_FAULTS_STATISTICS_DATA':
      return { ...state, faultsStatistics: action.data, isFetching: false };

    case 'SET_AGGREGATED_STATISTICS_DATA':
      return { ...state, aggregatedStatistics: action.data, isFetching: false };

    case 'SET_CONNECTION_STATISTICS_DATA':
      return { ...state, connectionStatistics: action.data, isFetching: false };

    case 'SET_TOTAL_ENERGY_STATISTICS_DATA':
      return { ...state, totalEnergyStatistics: { ...state.totalEnergyStatistics, ...action.data }, isFetching: false };

    default:
      return state;
  }
};

export default statistics;
